import React, { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import AuthLayout from '../../../../layouts/auth/AuthLayout';
import Button from '../../../common/button/Button';
import PasswordInput from '../../../common/input/password-input/PasswordInput';

import { ReactComponent as EmailIcon } from '../../../../resources/icons/email.svg';

import './login.scss';

type Props = {
  handleLogInClick: (email: string, password: string) => void;
};

const Login = ({ handleLogInClick }: Props) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    handleLogInClick(email, password);
  };

  return (
    <AuthLayout>
      <div className="login">
        <form className="login__form" onSubmit={handleSubmit}>
          <div className="login__input-container">
            <div className="login__input">
              <EmailIcon className="login__email-icon" />
              <input type="text" value={email} onChange={({ target }) => setEmail(target.value)} placeholder="email" />
            </div>
            <PasswordInput
              value={password}
              onChange={({ target }) => setPassword(target.value)}
              placeholder="password"
            />
          </div>

          <div className="login__link-container">
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>

          <div className="login__button-container">
            <Button text="Sign In" disabled={!email || !password} onClick={handleSubmit} auth />
            <Button text="Register" onClick={() => navigate('/register')} auth secondary />
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default Login;
